import { CSSProperties } from "react";

export default class DialogFooterViewStyle {
    
    dialogFooter : CSSProperties = {
        display : "flex",
        alignItems : "center",
        justifyContent : 'space-between',
        padding : 30,
        paddingTop: 0
    }
}